import { render, staticRenderFns } from "./CandidateOffered.vue?vue&type=template&id=81d9938c&scoped=true"
import script from "./CandidateOffered.vue?vue&type=script&lang=js"
export * from "./CandidateOffered.vue?vue&type=script&lang=js"
import style0 from "./CandidateOffered.vue?vue&type=style&index=0&id=81d9938c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d9938c",
  null
  
)

export default component.exports